import { ArchetypeDefinition } from '../../archetypeTypes';

export const INNOCENCE_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'innocent',
        name: 'Innocent',
        description: 'Simplicity, coherence, and safety-seeking stability.',
        category: 'Innocence',
        tags: ['simplicity', 'safety', 'coherence'],
        weights: { stability: 0.4, breathingQuality: 0.25, averageNodeEnergy: 0.2, nodeCount: 0.15 }
    }
];


